module.exports = __webpack_public_path__ + "images/picto-sect-reviews.png?8f43f";